import script from "./DeleteAttendeeConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteAttendeeConfirmation.vue?vue&type=script&setup=true&lang=js"

import "./DeleteAttendeeConfirmation.vue?vue&type=style&index=0&id=0e8afbb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e8afbb8"]])

export default __exports__